export default function StepCardBody({ count, name }) {
  return (
    <div className="step-body-card">
      <h5 className="text-center mt-2 mb-0">{count}</h5>
      <label className="w-100 text-center mb-2 text-muted">{name}</label>
    </div>
  );
}
